import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { TodoCard } from '../components/cards/todoCard';
import {
  DocumentForms,
  useDocumentStore,
} from '@roc/feature-documents';
import { useLoanStore } from '@roc/feature-loans';
import { LoanProcess, SERVICING } from '@roc/feature-utils';
import { Document } from '@roc/feature-types';
import { useEffect, useState } from 'react';
import { useLoanFlags } from '../hooks/useLoanFlags';
import { useLoanRoutes } from 'libs/feature-loans-routes-config/src/hooks/useLoanRoutes';
import { useHistory } from 'react-router-dom';
import { makeStyles, Theme } from '@material-ui/core/styles';

const FILTERED_STATUS = ['Not Applicable'];
const CUSTOM_SORTED_DOCUMENT_SECTIONS = [43];

const applyFilters = (documents: Document[]) => {
  const filteredDocs = documents.filter(
    doc => !FILTERED_STATUS.includes(doc.status)
  );
  if (
    documents.length > 0 &&
    CUSTOM_SORTED_DOCUMENT_SECTIONS.includes(documents[0].sectionId)
  )
    return filteredDocs;
  return filteredDocs.sort((a, b) =>
    a.taskName.localeCompare(b.taskName)
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '@media (max-width: 992px)': {
      marginLeft: '-6px',
    },
  },
}));

const processDocuments = (documentStore, section) => {
  const docs = applyFilters(
    documentStore.documents[SERVICING]?.[section.sectionName] || []
  );
  return docs.map((document: Document) =>
    documentStore.formatDocument(document, SERVICING)
  );
};

export const PostClosingTab = observer(() => {
  const { loanStore } = useLoanStore();
  const { documentStore } = useDocumentStore();
  const { loanDetails } = loanStore;
  const { loanTodosStore } = documentStore;
  const currentForm = documentStore.documentFormStore.currentForm;
  const loanId = loanDetails?.loanId;
  const { push } = useHistory();
  const { loanRoutesConfig } = useLoanRoutes();
  const { showPostClosing } = useLoanFlags();
  const [initialized, setInitialized] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (showPostClosing) {
      push(loanRoutesConfig.loans(loanId).children.postClosing.url);
    }
    loanTodosStore.setShowOnlyPending(false);
    loanTodosStore.setPrioritiesFilter([]);
    setInitialized(true);
  }, []);

  const todos =
    documentStore.loanTodosStore.todosByLoanProcess[LoanProcess.SERVICING] ?? [];

  useEffect(() => {
    documentStore.loanTodosStore.fetchTodos(loanId, LoanProcess.SERVICING);
  }, [loanId, currentForm]);

  return (
    <>
        <Grid item xs={12}>
          {initialized &&
            <Grid item xs={12} className={classes.container}>
              <TodoCard
                title={''}
                showSectionActions
                showFileName
                todos={todos}
                loanProcess={LoanProcess.SERVICING}
              />
            </Grid>
          }
          <DocumentForms loanId={loanId?.toString()} />
        </Grid>
    </>
  );
});
